import { useCustomLocale } from '@/app/[locale]/_hooks/useCustomLocale'
import { IRecommended } from '@/app/[locale]/_types'
import ProductCard from '@/app/[locale]/(home)/_components/Card'
import { Container, SimpleGrid, Stack, Text } from '@chakra-ui/react'
import React from 'react'
import useProductDiscount from '@/app/[locale]/_hooks/useProductDiscount'

const Recommended = ({
  recommended,
}: {
  recommended: { count: string; recommended_products: IRecommended[] }
}) => {
  const currentLocale = useCustomLocale()
  const { discounts } = useProductDiscount()

  return (
    <Container
      gap={6}
      maxW='1376px'
      display='flex'
      flexDir='column'
      px={{ lg: '44px' }}
    >
      {recommended?.recommended_products?.map((item, idx) => {
        return (
          <Stack
            gap={4}
            pb={{ base: 8, lg: 0 }}
            key={`${item?.id}-${item?.category_id}-${idx}`}
          >
            <Text
              fontWeight={700}
              textAlign={'center'}
              fontSize={{ base: 20, lg: 30 }}
            >
              {item?.type === 'text'
                ? item?.name?.[currentLocale]
                : item?.category_title?.[currentLocale]}
            </Text>
            <SimpleGrid
              gapX={{ base: '15px', lg: 6 }}
              gapY={{ base: 6, lg: 4 }}
              columns={{ base: 2, lg: 4 }}
              mb={{ base: 3, lg: 8 }}
            >
              {item?.products?.map((el) => (
                <ProductCard
                  categoryName={
                    item?.type === 'text'
                      ? item?.name?.[currentLocale]
                      : item?.category_title?.[currentLocale]
                  }
                  discounts={discounts}
                  product={el}
                  key={`${el?.id}-${item?.id}`}
                />
              ))}
            </SimpleGrid>
          </Stack>
        )
      })}
    </Container>
  )
}

export default Recommended
